// Define fields for both Mitral/Aortic and Tricuspid/Pulmonic valves
const valveFields = {
  mitral: [
    { key: 'mM2D', label: 'M-M/2D', options: ['WITHIN NORMAL LIMIT', 'MILD SCLEROSIS', 'SCLEROTIC', 'MITRAL ANNULAR CALCIFICATION', 'MITRAL STENOSIS - MILD', 'MITRAL STENOSIS - MODERATE', 'MITRAL STENOSIS - SEVERE'] },
    { key: 'regurge', label: 'REGURGE', options: ['NORMAL', 'TRIVIAL', 'MILD', 'MODERATE', 'MODERATE TO SEVERE', 'SEVERE'] },
    { key: 'stenosis', label: 'STENOSIS', options: ['NORMAL', 'TRIVIAL', 'MILD', 'MODERATE', 'MODERATE TO SEVERE', 'SEVERE'] },
    { key: 'flowE', label: 'FLOW (E wave)' },
    { key: 'flowA', label: 'FLOW (A wave)' },
    { key: 'pressTime', label: 'PRESS(½ TIME)' },
    { key: 'pressDecelTime', label: 'PRESS(Decel TIME)' },
    { key: 'mva', label: 'MVA' }
  ],
  aortic: [
    { key: 'mM2D', label: 'M-M/2D', options: ['WITHIN NORMAL LIMIT', 'BICUSPID', 'MILD SCLEROSIS', 'SCLEROTIC', 'CALCIFIC'] },
    { key: 'regurge', label: 'REGURGE', options: ['NORMAL', 'TRIVIAL', 'MILD', 'MODERATE', 'MODERATE TO SEVERE', 'SEVERE'] },
    { key: 'stenosis', label: 'STENOSIS', options: ['NORMAL', 'TRIVIAL', 'MILD', 'MODERATE', 'MODERATE TO SEVERE', 'SEVERE'] },
    { key: 'flow', label: 'FLOW' },
    { key: 'maxPG', label: 'MAX PG' },
    { key: 'meanPG', label: 'MEAN PG' },
    { key: 'ava', label: 'AVA' }
  ],
  tricuspid: [
    { key: 'mM2D', label: 'M-M/2D', options: ['WITHIN NORMAL LIMIT', 'MILD SCLEROSIS', 'SCLEROTIC'] },
    { key: 'regurge', label: 'REGURGE', options: ['NORMAL', 'TRIVIAL', 'MILD', 'MODERATE', 'MODERATE TO SEVERE', 'SEVERE'] },
    { key: 'flow', label: 'FLOW' },
    { key: 'trGradient', label: 'TR GRADIENT' },
    { key: 'paPressure', label: 'PA PRESSURE' }
  ],
  pulmonic: [
    { key: 'mM2D', label: 'M-M/2D', options: ['WITHIN NORMAL LIMIT', 'MILD SCLEROSIS', 'SCLEROTIC'] },
    { key: 'regurge', label: 'REGURGE', options: ['NORMAL', 'TRIVIAL', 'MILD', 'MODERATE', 'MODERATE TO SEVERE', 'SEVERE'] }
  ],
  technicianComments: [
    { name: 'trivialAorticInsufficiency', label: 'TRIVIAL AORTIC INSUFFICIENCY', type: 'dropdown', options: ['NORMAL STUDY', 'LIMITED STUDY', 'TECHNICALLY DIFFICULT STUDY'] },
    { name: 'noWallMotionAbnormalities', label: 'NO WALL MOTION ABNORMALITIES', type: 'dropdown', options: ['NO WALL MOTION ABNORMALITIES', 'ABNORMAL WALL MOTION INVOLVING - LAD DISTRIBUTION', 'ABNORMAL WALL MOTION INVOLVING - POSTERIOR', 'ABNORMAL WALL MOTION INVOLVING - INFERIOR', 'ABNORMAL WALL MOTION INVOLVING - POSTERIOR INFERIOR', 'ABNORMAL WALL MOTION INVOLVING - APEX'] },
    { name: 'normalEjectionFraction', label: 'NORMAL EJECTION FRACTION - 65%', type: 'dropdown', options: ['ESTIMATED EJECTION FRACTION', 'ESTIMATED EJECTION FRACTION - HYPERDYNAMIC','ESTIMATED EJECTION FRACTION - NORMAL DIASTOLIC FUNCTION', 'ESTIMATED EJECTION FRACTION - LOW NORMAL', 'ESTIMATED EJECTION FRACTION - MODERATELY DEPRESSED', 'ESTIMATED EJECTION FRACTION - SEVERELY DEPRESSED' ] },
    { name: 'normalVentricularThickness', label: 'NORMAL VENTRICULAR THICKNESS', type: 'dropdown', options: ['LEFT VENTRICULAR HYPERTROPHY - NORMAL', 'LEFT VENTRICULAR HYPERTROPHY - MILD', 'LEFT VENTRICULAR HYPERTROPHY - MODERATE', 'LEFT VENTRICULAR HYPERTROPHY - SEVERE', 'PRESERVED LEFT VENTRICULAR SYSTOLIC FUNCTION'] },
    { name: 'normalDiastolicFunction', label: 'NORMAL DIASTOLIC FUNCTION', type: 'dropdown', options: ['NORMAL DIASTOLIC FUNCTION', 'ABNORMAL DIASTOLIC FUNCTION', 'DIASTOLIC DYSFUNCTION'] },
    { name: 'sizeChambers', label: 'NORMAL SIZE CHAMBERS', type: 'dropdown', options: ['NORMAL SIZE CHAMBERS', 'DILATED - ALL CHAMBERS', 'DILATED - LEFT ATRIUM', 'DILATED - LEFT VENTRICLE', 'DILATED - RIGHT ATRIUM', 'DILATED - RIGHT VENTRICLE'] },
    { name: 'pulmonaryPressure', label: 'NORMAL PULMONARY ARTERY PRESSURE', type: 'dropdown', options: ['PULMONARY ARTERY PRESSURE'] },
    { name: 'pericardialEffusion', label: 'NO PERICARDIAL EFFUSION', type: 'dropdown', options: ['NO PERICARDIAL EFFUSION', 'PERICARDIAL EFFUSION - MILD', 'PERICARDIAL EFFUSION - MODERATE', 'PERICARDIAL EFFUSION - SEVERE'] },
    { name: 'intracavitaryMass', label: 'NO INTRACAVITARY MASS OR THROMBUS', type: 'dropdown', options: ['NO INTRACAVITARY MASS OR THROMBUS'] }
  ]
};
const allowedUsers = ["drmadhupr", "gowthamg", "gowtham"];

const initializeFormData = () => {
  const data = {};

  Object.keys(valveFields).forEach((section) => {
    data[section] = {};

    valveFields[section].forEach((field) => {
      if (field.options) {
        // Set first option as default
        if (section === "technicianComments") {
          data[section][field.name] = {
            dropdown: field.options[0],
            text: field.options[0]
          };
        } else {
          data[section][field.key || field.name] = field.options
            ? field.options[0]
            : '';
        }
      } else {
        data[section][field.key || field.name] = '';
      }
    });
  });

  return data;
};

// Reusable ValveSection component
const ValveSection = ({ title, valveType, formData, handleChange }) => {
  return (
    <div className="border p-3">
      <h6 className="text-xl font-semibold mb-2">{title}</h6>
      <div className="space-y-4">
        {valveFields[valveType].map(({ key, label, options }) => (
          <div key={key}>
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            
            {/* Check if options exist for dropdown */}
            {options ? (
              <select
                className="w-full border rounded px-3 py-2 mt-1"
                value={formData[valveType][key] || ''}
                onChange={(e) => handleChange(e, valveType, key)}
              >
                <option value="" disabled>Select an option</option>
                {options.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                className="w-full border rounded px-3 py-2 mt-1"
                value={formData[valveType][key] || ''}
                onChange={(e) => handleChange(e, valveType, key)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// Mitral and Aortic Valve Form
export const MitralAorticValves = ({ formData, handleChange }) => {
  return (
    <div className="py-8">
      <div className="grid grid-cols-2 gap-6 mb-2">
        <ValveSection 
          title="MITRAL VALVE"
          valveType="mitral"
          formData={formData}
          handleChange={handleChange}
        />
        <ValveSection 
          title="AORTIC VALVE"
          valveType="aortic"
          formData={formData}
          handleChange={handleChange}
        />
      </div>
    </div>
  );
};

// Tricuspid and Pulmonic Valve Form
export const TricuspidPulmonicForm = ({ formData, handleChange }) => (
  <div className="py-8">
    <div className="grid grid-cols-2 gap-6 mb-4">
      <ValveSection 
        title="TRICUSPID VALVE"
        valveType="tricuspid"
        formData={formData}
        handleChange={handleChange}
      />
      <ValveSection 
        title="PULMONIC VALVE"
        valveType="pulmonic"
        formData={formData}
        handleChange={handleChange}
      />
    </div>
  </div>
);

// Technical conclusions & comments
export const TechnicalComments = ({ formData, handleChange, userConfig }) => {
  const fields = valveFields.technicianComments;

  const renderInputField = (field) => {
    switch (field.type) {
      case 'checkbox':
        return (
          <input
            type="checkbox"
            checked={formData.technicianComments[field.name] || false}
            onChange={(e) => handleChange(e, 'technicianComments', field.name)}
          />
        );
      case 'dropdown':
        return (
          <select
            className="w-full border rounded px-3 py-2 mt-1"
            // value={formData.technicianComments[field.name] || ''}
            value={formData.technicianComments[field.name]?.dropdown || ''}
            onChange={(e) => {
  const value = e.target.value;

  handleChange(null, 'technicianComments', field.name, value, 'dropdown');
  handleChange(null, 'technicianComments', field.name, value, 'text'); // autofill
}}
          >
            <option value="" disabled>Select an option</option>
            {field.options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        );
      case 'text':
        return (
          <input
            type="text"
            className="w-full border rounded px-3 py-2 mt-1"
            value={formData.technicianComments[field.name] || ''}
            onChange={(e) => handleChange(e, 'technicianComments', field.name)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="mb-1">
      <h2 className="text-xl font-semibold mb-4"> 
        {allowedUsers.includes(userConfig?.username) ? (
          <div>IMPRESSIONS</div>
        ) : (
          <div>TECHNICIAN'S CONCLUSIONS AND COMMENTS</div>
        )}
      </h2>
      <div className="space-y-4">
        {fields.map((field, index) => (
          <div key={index} className="grid grid-cols-2 gap-2 py-1">
            <div>
              {/* <label className="block text-sm font-medium text-gray-700">{field.label}</label> */}
              {renderInputField(field)}
            </div>
            <div>
              
                {/* {field.label} */}
                <input
                  type="text"
                  className="w-full border rounded px-3 py-2 mt-1"
                  // value={formData.technicianComments[field.name] || ''}
                  // onChange={(e) => handleChange(e, 'technicianComments', field.name)}
                  value={formData.technicianComments[field.name]?.text || ''}
                  onChange={(e) => {
                      const value = e.target.value;
                      handleChange(null, 'technicianComments', field.name, value, 'text');
                    }}
                />
             
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};